import React, { useState, useEffect, useContext } from 'react';
import { CalculatorIcon, ViewGridAddIcon, CalendarIcon } from '@heroicons/react/outline';
import { PageTitle } from 'components/layouts/pageTitle';
import { joinClassNames } from 'utils/cssHelper';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { DeliverySettingsMainInfo } from './main';
// import { ProductsAddNewPricing } from './pricing';
// import { ProductsAddNewSchedule } from './schedule';

export const DeliverySettingsEditForm = ({ itemData, isEdit }) => {
  const navigation = [
    { name: 'Main info', href: '#', icon: ViewGridAddIcon, visible: true },
    { name: 'Restaurants', href: '#', icon: CalculatorIcon, visible: isEdit },
    { name: 'Categories', href: '#', icon: CalendarIcon, visible: isEdit },
  ];

  const { state: auth } = useContext(AuthContext);
  const { state: companyState, getCompanyRestaurants } = useContext(CompanyContext);

  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedRestaurants, setSelectedRestaurants] = useState(itemData?.restaurants || []);

  useEffect(() => {
    getCompanyRestaurants({ token: auth.token, companyId: auth.company?.company });
  }, []);

  const changeTabSelection = (e, selectedTabIndex) => {
    e.preventDefault();
    setSelectedTab(selectedTabIndex);
  };

  return (
    <>
      <PageTitle
        title="Delivery settings"
        breadcrumbs={[{ path: '/settings', title: 'Settings' }]}
        isTopLevel
      />
      <div className="container mx-auto px-2 md:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <aside className="pb-6 md:-mt-6 lg:-mt-0 px-0 lg:py-0 md:px-0 lg:col-span-3">
            <nav className="space-y-1">
              {navigation
                .filter((x) => x.visible)
                .map((item, tabIndex) => (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    key={item.name}
                    onClick={(e) => changeTabSelection(e, tabIndex)}
                    href="#"
                    className={joinClassNames(
                      tabIndex === selectedTab
                        ? 'bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white'
                        : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50',
                      'group rounded-md px-3 py-2 flex items-center text-sm font-medium',
                    )}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    <item.icon
                      className={joinClassNames(
                        tabIndex === selectedTab
                          ? 'text-indigo-500 group-hover:text-indigo-500'
                          : 'text-gray-400 group-hover:text-gray-500',
                        'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
                      )}
                      aria-hidden="true"
                    />
                    <span className="truncate">{item.name}</span>
                  </a>
                ))}
            </nav>
          </aside>

          <div className="sm:px-0 lg:col-span-9">
            <div className={selectedTab === 0 ? 'block' : 'hidden'}>
              <DeliverySettingsMainInfo
                itemData={itemData}
                isEdit={isEdit}
              />
            </div>
            {isEdit && (
              <div className={selectedTab === 1 ? 'block' : 'hidden'}>
                {/* <ProductsAddNewPricing itemData={itemData} isEdit={isEdit} /> */}
              </div>
            )}
            {isEdit && (
              <div className={selectedTab === 2 ? 'block' : 'hidden'}>
                {/* <ProductsAddNewSchedule
                  itemData={itemData}
                  restaurants={companyState.restaurants}
                  selectedRestaurants={selectedRestaurants}
            /> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
